import React from "react";
import { connect } from "react-redux";

import {
  getUnreadChatsCount,
  getUnreadChatsCountWithoutChat,
} from "../../../selectors/chat/chat";
import Notification from "./Notification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";

type BackButtonArgs = {
  onClick: () => void;
  counter?: number;
};
const BackButton = ({ onClick, counter }: BackButtonArgs) => (
  <button
    onClick={onClick}
    title={I18n.t("js.chat.back_button.title")}
    aria-label={I18n.t("js.chat.back_button.title")}
    className="btn btn-sm relative chat__header_action"
  >
    <FontAwesomeIcon icon={faArrowLeft} />
    <Notification counter={counter} className={"!absolute"} />
  </button>
);

const BackToRootButton = connect(
  (state, { chatId }: { chatId?: string }) => ({
    counter: chatId
      ? getUnreadChatsCountWithoutChat(state, { chatId })
      : getUnreadChatsCount(state),
  }),
  (dispatch) => ({
    onClick: () =>
      dispatch({ type: "chat/NAVIGATE", payload: { route: "root" } }),
  }),
)(BackButton);

export { BackToRootButton };

export default BackButton;
